import useSWR from "swr";
import Card from "components/global/card";
import COMPANIES_QUERY from "queries/companies";

export default function Companies() {
  const { data, error } = useSWR(COMPANIES_QUERY);

  if (error) {
    console.error(error);
  }

  return (
    <div className="mb-10 space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0">
      {data?.companies?.map((company) => (
        <Card
          link={`/company/${company.Slug}`}
          title={company.Name}
          image={company.MainPhoto}
          type="company"
          key={`company-card-${company.id}`}
        />
      ))}
    </div>
  );
}
